import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class ErrorhandlerService {
  constructor(private snackBar: MatSnackBar) {}

  handleError(error: any) {
    if (error && error.error && error.error.code) {
      if (error.error.code > 900000 && error.error.code < 1000000) {
        this.showG4Error();
      } else if (error.error.code === 1001) {
        this.ShowTimeoutError();
      } else {
        this.ShowGenericError();
      }
    } else {
      this.ShowGenericError();
    }
  }
  ShowGenericError(): void {
    this.snackBar.open('Der opstod en uventet fejl.', '', {
      duration: 3000,
      verticalPosition: 'top',
    });
  }

  ShowTimeoutError(): void {
    this.snackBar.open('Timeout. Prøv igen', '', {
      duration: 3000,
      verticalPosition: 'top',
    });
  }

  showG4Error() {
    this.snackBar.open(
      'De eksterne systemer svarer ikke i øjeblikket. Prøv venligst senere',
      'OK',
      {
        verticalPosition: 'top',
      }
    );
  }
}
